import type { ClientUploadProgressPayload } from '@minusjs/tuf/client';
import type { Files } from '../../ports/files';
import type { OperationFile } from './sync';
import { files as managementFiles } from '../management/files';
import { idb, socketIo } from './sync';
import { cleanUploads } from './sync/clean';

class OperationsFiles implements Files {
  public async save(
    filename: string,
    blob: Blob,
    progress?: (payload: ClientUploadProgressPayload) => unknown,
  ): Promise<OperationFile> {
    const path = `uploads/gmao/${new Date().getTime()}-${filename}`;
    const file: OperationFile = {
      path,
      blob,
      createdAt: new Date().toISOString(),
    };

    await idb.files.put(file);
    if (socketIo.connected) {
      try {
        await managementFiles.save(filename, blob, progress, path);
      }
      catch {
        // The blob stays on the device: the next sync uploads the files missing on the server
      }
    }
    await cleanUploads();

    return file;
  }

  public async get(path: string): Promise<OperationFile> {
    const file = await idb.files.get(path);
    if (file)
      return file;
    if (socketIo.connected) {
      const file = await managementFiles.get(path);
      await idb.files.put(file);
      return file;
    }
    throw new Error(`File not found`);
  }
}

export const files = new OperationsFiles();
